import React from "react";
import { Box, Typography, Container, List, ListItem, ListItemText, Paper, Divider } from "@mui/material";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { tokens } from "../theme/tokens";

const AboutUs = () => (
  <>
    <Header />
    <Box
      component="main"
      sx={{
        pt: { xs: "88px", md: "96px" },
        minHeight: "72vh",
        bgcolor: tokens.surface,
        py: { xs: 4, md: 6 },
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, sm: 5 },
            borderRadius: `${tokens.radiusLg}px`,
            border: `1px solid ${tokens.border}`,
            boxShadow: tokens.shadowMd,
          }}
        >
          <Typography
            variant="overline"
            sx={{ color: tokens.accent, fontWeight: 700, letterSpacing: "0.12em" }}
          >
            TripTrip India
          </Typography>
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
              fontFamily: tokens.fontDisplay,
              fontWeight: 700,
              color: tokens.brand,
              letterSpacing: "-0.02em",
              fontSize: { xs: "1.75rem", sm: "2.25rem" },
            }}
          >
            About us
          </Typography>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, color: tokens.text, mt: 2 }}>
            Overview
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: tokens.textMuted, lineHeight: 1.75 }}>
            Tired of wasting hours hunting for business hotels that are either overpriced or
            underwhelming?
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: tokens.textMuted, lineHeight: 1.75 }}>
            We were too. That is why we created TripTrip — your corporate travel companion built to end
            the chaos of business hotel booking.
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: tokens.textMuted, lineHeight: 1.75 }}>
            Born from the frustration of juggling a dozen tabs, hidden fees, and last-minute
            cancellations, TripTrip exists to transform the way your business books hotels. Our platform
            is designed for speed, simplicity, and reliability — because your team deserves better than
            budget rooms that feel like a punishment.
          </Typography>
          <Divider sx={{ my: 3 }} />
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, color: tokens.text }}>
            What we offer
          </Typography>
          <List dense sx={{ color: tokens.textMuted }}>
            <ListItem sx={{ display: "list-item", pl: 0 }}>
              <ListItemText primary="Mostly refundable stays — peace of mind built-in" />
            </ListItem>
            <ListItem sx={{ display: "list-item", pl: 0 }}>
              <ListItemText primary="Instant confirmations — no more pending stress" />
            </ListItem>
            <ListItem sx={{ display: "list-item", pl: 0 }}>
              <ListItemText primary="24/7 booking access — because business never sleeps" />
            </ListItem>
            <ListItem sx={{ display: "list-item", pl: 0 }}>
              <ListItemText primary="Integrated, secure payments — travel finance made simple" />
            </ListItem>
            <ListItem sx={{ display: "list-item", pl: 0 }}>
              <ListItemText primary="Clean, consistent hotel experiences — every time" />
            </ListItem>
          </List>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, color: tokens.text, mt: 2 }}>
            The results speak for themselves
          </Typography>
          <List dense sx={{ color: tokens.textMuted }}>
            <ListItem sx={{ display: "list-item", pl: 0 }}>
              <ListItemText primary="40% faster booking times for corporate teams" />
            </ListItem>
            <ListItem sx={{ display: "list-item", pl: 0 }}>
              <ListItemText primary="98% satisfaction rate from business travelers" />
            </ListItem>
            <ListItem sx={{ display: "list-item", pl: 0 }}>
              <ListItemText primary="Thousands of nights booked by professionals who value ease over effort" />
            </ListItem>
          </List>
          <Box
            sx={{
              mt: 4,
              p: 3,
              borderRadius: `${tokens.radiusMd}px`,
              bgcolor: tokens.accentSoft,
              border: `1px solid ${tokens.border}`,
            }}
          >
            <Typography variant="body1" sx={{ color: tokens.text, lineHeight: 1.75 }}>
              <strong>Ready to travel smarter?</strong>
              <br />
              Join the companies making better bookings every day. Visit our website or message us on the
              contact page to get started.
            </Typography>
            <Typography variant="body1" sx={{ mt: 2, fontWeight: 600, color: tokens.brand }}>
              TripTrip — For business travel that is quick, clean, and sharp.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
    <Footer />
  </>
);

export default AboutUs;
